import React, { useEffect, useState } from "react";
import Footer from "../component/Footer";
import Header2 from "../component/Header2";
import { Helmet } from "react-helmet";
import axios from "axios";
import { Link, useParams } from "react-router-dom";

function Services_details() {
  useEffect(() => {
    fetch();
    document.getElementById('spinner').style.display="none";
  });
  const { id } = useParams();
  const [data, setData] = useState([]);
  const fetch = async () => {
    const res = await axios.get(`https://www.rajvicosmeticclinic.com/RajviApi/services_single_get?id=${id}`);
    console.log(res.data);
    setData(res.data);
  }
  return (
    <>

      <Header2 title="Services" />
      <div>
        <div className="container-fluid px-0 py-5 my-5">
          <div className="row mx-0 justify-content-center text-center">
            <div className="col-lg-6">
              <h6 className="d-inline-block bg-light text-primary text-uppercase py-1 px-2">
                Our Service
              </h6>
              <h1>Hair &amp; Skin Services</h1>
              <div class="spinner-border text-danger mt-5" id='spinner'></div>
            </div>
          </div>
          {
            (data.length > 0) ? data && data.map((value) => {
              return (
                <div className="container-fluid py-5">
                  <div className="container py-5">
                    <div className="row">
                      <div className="col-lg-6" style={{ minHeight: 500 }}>
                        <div className="position-relative h-100">
                          <img className="position-absolute w-100 h-100" src={`https://www.rajvicosmeticclinic.com/RajviApi/upload/services/${value.ser_img}`} style={{ objectFit: 'cover' }} />
                        </div>
                      </div>
                      <div className="col-lg-6 pt-5 pb-lg-5">
                        <div className="hours-text bg-light p-4 p-lg-5 my-lg-5">
                          <h1 className="d-inline-block text-white text-uppercase bg-primary py-1 px-2">{value.service_name}</h1>
                          <h1 className="mb-4"></h1>
                          <p>{value.desc}</p>
                          <ul className="list-inline">
                            <li className="h6 py-1"><i className="far fa-circle text-primary mr-3" />{value.description}</li>
                            <li className="h6 py-1"><i className="far fa-circle text-primary mr-3" />Rs. {value.price}/-</li>
                          </ul>
                          <Link to='/Appointment_book' className="btn btn-primary mt-2">Book Now</Link>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              )
            }) : null
          }
        </div>
        {/* Service End */}
        {/* Testimonial Start */}

      </div>

      <Footer />

      
    </>
  );
}

export default Services_details;
